/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Export_Usage_MoreInputs */



/**
* | output |
* | --- |
* | "…and {count} more in the file" |
*
* @param {Admin_Export_Usage_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_usage_more = /** @type {((inputs: Admin_Export_Usage_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Usage_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`…und ${i?.count} weitere in der Datei`)
	return /** @type {LocalizedString} */ (`…and ${i?.count} more in the file`)
});